import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Eyebrow from '../atoms/Eyebrow';
import Button from '../atoms/Button';
import { createCheckoutSession } from '@/api/billing';

// Soft, contextual subscribe nudge. Shown on the report page after a trial
// resolves. PR-UX-10 flow · azure tone (not vermilion → not destructive),
// not a modal, not blocking.
//
// Per EXPERIENCE.md derived gap #4 + JT-05 → JT-01 transition.
interface SubscribeNudgeProps {
  className?: string;
}

export default function SubscribeNudge({ className = '' }: SubscribeNudgeProps) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onClick = async () => {
    setBusy(true);
    setError(null);
    try {
      const r = await createCheckoutSession();
      window.location.href = r.checkout_url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Checkout failed');
      setBusy(false);
    }
  };

  return (
    <aside
      className={`bg-paper border border-azure/30 rounded-lg p-6 mb-8 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 ${className}`}
      aria-label={t('subNudge.aria')}
    >
      <div className="flex-1">
        <Eyebrow tone="azure" className="mb-2">{t('subNudge.eyebrow')}</Eyebrow>
        <h3 className="font-serif text-xl font-medium mb-1">{t('subNudge.title')}</h3>
        <p className="text-sm text-ink-2">{t('subNudge.body')}</p>
        {error && <p className="text-sm text-vermilion-700 mt-2">{error}</p>}
      </div>
      <Button variant="primary" onClick={onClick} loading={busy} className="shrink-0">
        {t('subNudge.cta')}
      </Button>
    </aside>
  );
}
